<template>
  <div class="bodys" v-if="body_show">
    <!-- 我的头部 -->
    <public-top :uid="uid" :headimgurl="headimgurl" :nickname="nickname"></public-top>
    <div class="ban_main">
      <ul>
        <li @click="person_click(1)">
          我的课程
          <img src="@a/href.png" />
        </li>
        <!-- <li @click="person_click(2)">
          我的辅导
          <img src="@a/href.png" />
        </li> -->
        <li @click="person_click(3)">
          我的测评
          <img src="@a/href.png" />
        </li>
        <li @click="$router.push('/promotion_center')">
          推广中心
          <img src="@a/href.png" />
        </li>
        <li @click="person_click(4)">
          我的账户
          <img src="@a/href.png" />
        </li>
        <li  class="last"  @click="person_click(5)">
          我的邀请
          <img src="@a/href.png" />
        </li>
      </ul>
    </div>
    <div class="ban_main">
      <ul>
        <li>
          <router-link to="/achievement">
            达成成就
            <img src="@a/href.png" /><img src="@a/chece.png" class="chece" />
          </router-link>
        </li>
        <li :class="obj.obj_tip1 === true ? 'pr item_tip_box' : ''">
          <router-link :to="{
            path:'/certificate',
            query:{
              pop_cid:'',
              pop_type:''
              }
            }">
            我的证书
            <img src="@a/href.png" />
          </router-link>
          <div v-if="obj.obj_tip1" class="tar_item" @click="nextTips">
            我的证书
          </div>
          <div v-if="obj.obj_tip1" class="obj_tip1 obj_tip_style" @click="nextTips">
            <span>恭喜您，您已成为助教!可在我的证书内领取助教聘书~</span>
          </div>
        </li>
        <li @click="follow_show = true">
          <a href="javascript:;">
              关注我们
              <img src="@a/href.png" />
            </a>
        </li>
        <!--  -->
        <li v-if="isReply && !isTutor" :class="obj.obj_tip2 === true ? 'pr item_tip_box' : ''">
          <router-link :to="'/ta_informations?cid='+course_id">
            申请成为助教
            <img src="@a/href.png" />
          </router-link>
          <div v-if="obj.obj_tip2" class="tar_item" @click="closeTips">
            申请成为助教
          </div>
          <div v-if="obj.obj_tip2" class="obj_tip1 obj_tip_style" @click="closeTips">
            <span>为了方便您便于管理班级小组，可通过以下操作在导师端进行管理</span>
          </div>
        </li>
        <li v-if="isTutor" :class="obj.obj_tip2 === true ? 'pr item_tip_box' : ''">
          <router-link :to="'/ta_period_time_list?cid='+ course_id">
            我是助教
            <img src="@a/href.png" />
          </router-link>
          <div v-if="obj.obj_tip2" class="tar_item" @click="closeTips">
            我是助教
          </div>
          <div v-if="obj.obj_tip2" class="obj_tip1 obj_tip_style" @click="closeTips">
            <span>为了方便您便于管理班级小组，可通过以下操作在导师端进行管理</span>
          </div>
        </li>
        <!-- 申请其它课程期次助教 -->
        <li v-if="isTutor && !isMain">
          <a @click="toSuccess()">
            申请其他期次助教
            <img src="@a/href.png" />
          </a>
        </li>
        <li class="last">
          <router-link :to="'/team?cid='+ course_id">
            我的小组
            <img src="@a/href.png" />
          </router-link>
        </li>
      </ul>
    </div>
    <div class="ban_main">
      <ul>
        <li class="last" >
          <a :href="relogin()">
            重新登录
            <img src="@a/href.png" />
          </a>
        </li>
      </ul>
    </div>
    <!-- 公用底部 -->
    <public-footer :childMsg="1" :routArg="routArg"></public-footer>
    <!-- 未参加课程或辅导 -->
    <van-popup class="pub_alert" v-model="alert_show">
      <!-- 课程 -->
      <div class="confirm_box" v-if="course_type==1">
        <h2>您还未报名课程</h2>
        <p>快去报名吧</p>
        <div class="btn_group">
          <a class="confirm" href="javascript:;" @click="signUpCourse">去报名</a>
        </div>
      </div>
      <!-- 辅导 -->
      <div class="confirm_box" v-if="course_type==2">
        <h2>您还未报名辅导</h2>
        <p>快去参加吧</p>
        <div class="btn_group">
          <a class="confirm" href="javascript:;" @click="signUpTotoring">去参加</a>
        </div>
      </div>
    </van-popup>
    <!-- 关注公众号 -->
    <van-popup class="follow-public-account" v-model="follow_show">
      <div class="box">
        <img src="@a/carrer.png">
        <h4>长按识别上方二维码关注我们</h4>
      </div>
    </van-popup>
    <transition name="opct">
      <div class="fixed-bg" v-show="fixedBg" @click="nextTips(true)">
        <div v-if="obj.obj_tip2" class="close-btn tip-btns" @click="closeTips">关闭</div>
        <div v-else class="next-btn tip-btns" @click="nextTips">下一步</div>
      </div>
    </transition>
    <van-popup v-model="end_show" style="background: none">
      <div class="pop_end_box">
        <h2><span>{{invite.fullname}}</span> 助教</h2>
        <p>感谢您在往期{{invite.bname}}的付出和贡献：带出来任务达成率和出勤率双高小组，成为学员评价极好的助教！</p>
        <p>现诚挚邀请您担任{{invite.bname}}{{invite.name}}助教。批次成就，共同成长。期待您的加入！</p>
        <div class="pull-right">
          <img src="@a/end_logo.png" alt="" />
          <h3>新精英人才加速器<br/>{{invite.create_time}}</h3>
        </div>
        <div class="clearfix"></div>
        <div class="clearfix">
          <a @click="inviteDo(2)">拒绝</a>
          <a @click="inviteDo(1)">接受</a>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  inviteDo
} from "@/api/assistant";
import {
  isMain,
  queryString,
  getStorage,
  setStorage
} from "@/utils/tools";
import {
  my
} from "@/api/person"
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        isMain: isMain(),
        fixedBg: false,
        body_show: false,
        uid: '',
        headimgurl: "",
        nickname: "",
        course_id: '',
        alert_show: false,
        course_type: 0,
        curriculum: false,
        course: false,
        cid: null,
        order: false,
        bid: null,
        follow_show: false,
        courseLink: '',
        xplan: "",
        routArg: {},
        obj: {
          obj_tip1: false,
          obj_tip2: false
        },
        isTutor: false,
        invite: {},
        end_show: false,
        data:{}
      };
    },
    methods: {
      /*
       *@param: 
       *@return: 
       *@Description: 重新登录
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2020-05-22 10:36:08
      */
      relogin(){
        let link = window.location.href;
        if(link.indexOf('?')>-1){
          return (link+'&method=relogin');
        }else{
          return (link+'?method=relogin');
        }
      },
      // 已有申请直接跳转成功页面
      toSuccess(){
        if (this.data.apply_list.length>0) {
          this.$router.push({
            path:'/ta_askfor_result',
            query:{
              bid:this.data.apply_list[0].cid
            }
          })
        }else{
          this.$router.push('/ta_informations?cid='+this.course_id);
        }
      },
      nextTips(bool) {
        if (!this.obj.obj_tip1 && this.obj.obj_tip2 && bool) {
          this.closeTips();
          return
        }
        if (this.obj.obj_tip1 && !this.obj.obj_tip2) {
          this.obj.obj_tip1 = false;
          this.obj.obj_tip2 = true;
        } else {
          this.obj.obj_tip1 = true;
          this.obj.obj_tip2 = false;
        }
      },
      closeTips() {
        this.fixedBg = false;
        this.obj.obj_tip1 = false;
        this.obj.obj_tip2 = false;
      },
      inviteDo(state) {
        inviteDo({
          id: this.invite.id,
          state: state
        }).
        then((data) => {
          this.end_show = false;
          if (state == 1) {
            setTimeout(() => {
              // 开启提示
              this.fixedBg = true;
              this.obj.obj_tip1 = true;
            }, 200)
          };
        });
      },
      pullData() {
        // 清空缓存
        if (this.$route.query.resetCache === 'true') {
          setStorage('/person', 'assistantTip', '');
        }
        //调用加载中
        this.$emit('loadingHandle',true,"拼命加载中...");
        my().then(data => {
          this.body_show = true;
          //关闭加载中
          this.$emit('loadingHandle',false);
          
          this.data = data;
          this.uid = data.uid;
          this.headimgurl = data.headimgurl;
          this.nickname = data.nickname;
          this.course_id = data.course_id;
          this.curriculum = data.curriculum;
          this.course = data.course;
          this.cid = data.course_id;
          this.order = data.order;
          this.bid = data.bid;
          this.courseLink = data.course_link;
          this.xplan = data.xplan;
          this.invite = data.invite;
          this.end_show = data.invite.id ? true : false;
          let querys = this.$route.query;
          if (querys.source) {
            this.routArg['source'] = querys.source;
          }
          if (querys.pdk) {
            this.routArg['pdk'] = querys.pdk;
          }
          if (querys.aspx) {
            this.routArg['aspx'] = querys.aspx;
          }
          // this.isAllowJoinTeam = !data.isTutor && data.isReply
          this.isTutor = data.isTutor;
          this.isReply = data.isReply;
          if (this.isTutor && !getStorage('/person', 'assistantTip')) {
            setTimeout(() => {
              // 开启提示
              this.fixedBg = true;
              this.obj.obj_tip1 = true;
              setStorage('/person', 'assistantTip', 'true');
            }, 200)
          }
        });
      },
      person_click(num) {
        let querys = this.$route.query;
        if (num == 1) {
          this.$router.push({
            path: '/my_course',
            query: querys
          });
          // if(this.curriculum) {
          //   window.location.href = this.courseLink;
          // } else {
          //   this.course_type = num;
          // }
        } else if (num == 2) {
          if (this.order) {
            this.$router.push({
              path: '/totoring_buy_success',
              query: {
                pay: 'my'
              }
            });
          } else {
            this.course_type = num;
          }
        } else if (num == 3) {
          this.$router.push({
            path: '/measurement_details',
            query: {
              cid: queryString(this.xplan, "cid"),
              strips: queryString(this.xplan, "strips")
            }
          });
        } else if (num == 4) {
          // 我的账户
          this.$router.push({
            path: '/my_account'
          });
        } else if (num == 5) {
          // 我的邀请
          this.$router.push({
            path: '/my_invitation'
          });
        }
        this.alert_show = true;
      },
      // 去报名课程
      signUpCourse() {
        window.location.href = this.courseLink;
      },
      // 去报名辅导
      signUpTotoring() {
        this.$router.push({
          path: '/mentor_details'
        });
      }
    },
    created() {
      this.pullData();
      shareCon("index", this);
    }
};
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.bodys {
  text-align: center;
  padding-bottom: 120px
}

.ban_main {
  width: 100%;
  margin-top: changeRem(.6) + px;
  background: #fff;
  li {
    line-height: changeRem(1.8) + px;
    border-bottom: 2px solid #ccc;
    color: #333;
    font-size: changeRem(.68) + px;
    padding-right: changeRem(.6) + px;
    text-align: left;
    cursor: pointer;
    padding-left: changeRem(.6) + px;
    a {
      display: block;
      width: 100%;
      height: 100%;
      color: #333;
      img.chece {
        width: changeRem(1.6) + px;
        height: changeRem(1.6) + px;
        margin-top: changeRem(.1) + px;
        margin-right: changeRem(1) + px;
      }
    }
    img {
      float: right;
      width: changeRem(.56) + px;
      vertical-align: middle;
      margin-top: changeRem(.6) + px;
    }
  }
  li.last {
    border-bottom: none
  }
}

.confirm_box {
  h2 {
    padding-bottom: 12px;
  }
  p {
    margin-bottom: 50px;
    font-size: 26px;
    color: #666;
  }
  .btn_group {
    .confirm {
      width: 100%;
    }
  }
}

.follow-public-account {
  background: transparent;
  .box {
    padding: 73px 80px 80px;
    border-radius: 8px;
    background: #fff;
    img {
      width: 434px;
      height: 434px;
    }
    h4 {
      font-size: 32px;
      color: #333;
      margin-top: 40px;
    }
  }
}

.item_tip_box {
  z-index: 99999999;
  .tar_item {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    padding-left: changeRem(.6) + px;
  }
  .obj_tip_style {
    border-radius: 10px;
    font-size: 26px;
    line-height: 40px;
  }
  .obj_tip1 {
    position: absolute;
    bottom: 112px;
    left: 30px;
    right: 30px;
    background: #fff;
    padding: 30px;
  }
}

.fixed-bg {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  .tip-btns {
    padding: 10px 20px;
    background: #fff;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-size: 20px;
    position: absolute;
    right: 10px;
    top: 10px;
  }
}

.opct-enter-active,
.opct-leave-active {
  transition: opacity .3s;
}

.opct-enter,
.opct-leave-to {
  opacity: 0;
}

.pop_end_box {
  width: 623px;
  height: 761px;
  background: url(../../../assets/end_bg.png);
  background-size: cover;
  padding: 97px 75px 58px 75px;
  text-align: center;
  h2 {
    font-size: 26px;
    color: #333;
    text-align: left;
    span {
      font-size: 34px;
    }
    margin-bottom: 10px;
  }
  p {
    font-size: 26px;
    color: #333;
    line-height: 34px;
    margin-top: 20px;
    text-align: justify;
  }
  img {
    margin-top: 10px;
    width: 42px;
  }
  h3 {
    font-size: 22px;
    color: #333;
    line-height: 34px;
    margin-top: 10px;
  }
  a {
    font-size: 34px;
    color: #ccc;
    line-height: 66px;
    width: 174px;
    height: 66px;
    border: 2px solid rgba(204, 204, 204, 1);
    border-radius: 33px;
    float: left;
    margin-top: 116px;
  }
  a:last-child {
    border-color: #fff;
    color: #fff;
    float: right;
  }
}
</style>
